import { render, staticRenderFns } from "./painelgerirturmas.vue?vue&type=template&id=eaa13ffc&"
import script from "./painelgerirturmas.vue?vue&type=script&lang=js&"
export * from "./painelgerirturmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports